module.exports = __webpack_public_path__ + "img/26fd2fb.png";